module.exports = __webpack_public_path__ + "static/media/logo_landing@3x.d353ff87.jpg";